import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TrackedVisitorDTO, VisitorTrackerDTO } from '../../../services/api/api';
import { SbDateTime } from '../../../services/api/api-date-time';
import { TrackerValuesInterface } from '../tracker-values-element/tracker-values-element.component';
import { UtilService } from '../../../services/util.service';

@Component({
  selector: '[sb-comp-tracker-values-line]',
  templateUrl: './tracker-values-line.component.html',
  styleUrls: ['./tracker-values-line.component.scss'],
  standalone: false,
})
export class TrackerValuesLineComponent implements OnInit {
  @Input() tracker: VisitorTrackerDTO;
  // tslint:disable-next-line:variable-name
  _trackedVisitor: TrackedVisitorDTO;
  @Input() set trackedVisitor(val: TrackedVisitorDTO) {
    this._trackedVisitor = val;
  }

  get trackedVisitor(): TrackedVisitorDTO {
    return this._trackedVisitor;
  }

  @Input() date: SbDateTime;
  // tslint:disable-next-line:variable-name
  _editMode: number;
  @Input() set editMode(val: number) {
    this._editMode = val;
    if (val === -1 && this.initialEmpty) {
      this._trackedVisitor = undefined;
    }
  }

  get editMode(): number {
    return this._editMode;
  }

  @Output() changedLineEmitter: EventEmitter<TrackedVisitorDTO>;

  initialEmpty: boolean;
  elements: number[];

  constructor(public util: UtilService) {
    this._trackedVisitor = undefined;
    this.initialEmpty = false;
    this.changedLineEmitter = new EventEmitter<TrackedVisitorDTO>();
    this.elements = Array.from(new Array(24), (x, i) => i);
  }

  ngOnInit(): void {}

  createValuesForDate() {
    this.initialEmpty = true;
    this.trackedVisitor = new TrackedVisitorDTO();
    this.trackedVisitor.date = this.date;
    this.trackedVisitor.unique = Array(24).fill(null);
    this.trackedVisitor.dwellTime = Array(24).fill(null);
    this.trackedVisitor.count = Array(24).fill(null);
  }

  getTrackerValueElementData(pIndex: number): TrackerValuesInterface {
    if (this.trackedVisitor) {
      return {
        index: pIndex,
        count: this.trackedVisitor.count[pIndex],
        unique: this.trackedVisitor.unique[pIndex],
        dwellTime: this.trackedVisitor.dwellTime[pIndex],
      };
    } else {
      return { index: pIndex, count: null, unique: null, dwellTime: null };
    }
  }

  handleValueUpdate(updateValues: TrackerValuesInterface) {
    if (updateValues) {
      this.trackedVisitor.count[updateValues.index] = updateValues.count;
      this.trackedVisitor.unique[updateValues.index] = updateValues.unique;
      this.trackedVisitor.dwellTime[updateValues.index] = updateValues.dwellTime;
      this.changedLineEmitter.emit(this.trackedVisitor);
    }
  }
}
